import { useMemo, useState } from 'react';
import {
  getLocalAutomationsCatalog,
  getLocalSuggestedAutomationsCatalog,
  toggleLocalAutomationRenewalStatus,
} from '@/modules/automations/services';
import { calculateAutomationStats } from '@/modules/automations/utils';

const initialActiveAutomations = getLocalAutomationsCatalog();
const initialSuggestedAutomations = getLocalSuggestedAutomationsCatalog();

export function useAutomationsOverview() {
  const [activeTab, setActiveTab] = useState('attive');
  const [activeAutomations] = useState(initialActiveAutomations);
  const [suggestedAutomations] = useState(initialSuggestedAutomations);
  const [renewalStatus, setRenewalStatus] = useState({ 1: true });

  const stats = useMemo(() => calculateAutomationStats(activeAutomations), [activeAutomations]);

  function toggleRenewal(id) {
    const result = toggleLocalAutomationRenewalStatus(renewalStatus, id);
    if (!result.ok) return result;

    setRenewalStatus(result.data.renewalStatus);
    return result;
  }

  return {
    activeTab,
    setActiveTab,
    activeAutomations,
    suggestedAutomations,
    renewalStatus,
    toggleRenewal,
    stats,
  };
}
